export const host = import.meta.env.VITE_APP_API_HOST;
export const domainName = `${import.meta.env.VITE_APP_DOMAIN_NAME}`;
export const googleMapKey = `${import.meta.env.VITE_APP_GOOGLE_MAP_KEY}`;
export const sentryDSN = `${import.meta.env.VITE_APP_SENTRY_DSN}`;
export const sentryEnvironment = `${import.meta.env.VITE_APP_SENTRY_ENV}`;
export const loginRetailerUrl = `${import.meta.env.VITE_APP_RETAILER_URL}`;
export const appVersion = `${import.meta.env.VITE_APP_VERSION}`;
export const posthogPublicKey = `${import.meta.env.VITE_PUBLIC_POSTHOG_KEY}`;
export const posthogHost = `${import.meta.env.VITE_PUBLIC_POSTHOG_HOST}`;
